var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"items":_vm.titles,"label":_vm.$t('users.components.academic-title-select.label')},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }